import React from 'react';
import VHDefaultChatInputArea from '../../default/VHDefaultChatInputArea/VHDefaultChatInputArea';
import BranchingInputArea from '../../branching/BranchingInputArea/BranchingInputArea';
import VhTypes from '../../configs/VHTypes';
import { useVHTypeConfig } from '../../vhTypeHooks';
import { useSelector } from 'react-redux';
import {
  ChatStates,
  selectChatState,
  virtualHumanTalkingSelector,
} from '@vh/slices/chat/ChatSlice';

const VhTypeInputSelector = () => {
  const vhTypeConfig = useVHTypeConfig();
  const chatState = useSelector(selectChatState);
  const sessionComplete = ChatStates.COMPLETE === chatState;
  const vhTalking = useSelector(virtualHumanTalkingSelector);
  if (vhTypeConfig.type === VhTypes.BRANCHING) {
    return <BranchingInputArea />;
  }
  if (sessionComplete && !vhTalking) {
    return <></>;
  }
  return <VHDefaultChatInputArea />;
};

export default VhTypeInputSelector;
